import { baseApi, METHODS } from '../baseApi';
import { serializeParams } from '../helpers';
import { ApiArgs } from '../types';

import { GetAdPayload, GetAdResponse, TrackAdImpressionPayload } from './types';

export const AD_TAGS = {
  ADS: 'ads',
};

export const adsApi = baseApi
  .enhanceEndpoints({ addTagTypes: Object.values(AD_TAGS) })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAds: builder.query<GetAdResponse, ApiArgs<void, GetAdPayload>>({
        query: (params) => ({
          url: `/ads${serializeParams(params.payload)}`,
          method: METHODS.GET,
          headers: { 'x-api-version': '1' },
        }),
      }),
      trackAdImpression: builder.mutation<
        void,
        ApiArgs<void, TrackAdImpressionPayload>
      >({
        query: (params) => ({
          url: '/ads/track-impression',
          method: METHODS.POST,
          headers: { 'x-api-version': '1' },
          body: params.payload,
        }),
      }),
    }),
    overrideExisting: true,
  });

export const { useGetAdsQuery, useTrackAdImpressionMutation } = adsApi;
